"use strict";
module.exports = {
  BorderRadiusBaseBase:"2px",
  BorderRadiusBaseLarge:"6px",
  BorderRadiusButtonBase:"2px",
  BorderWidthBaseBase:"1px",
  BorderWidthBaseThick:"2px",
  BorderWidthButtonBase:"1px",
  BorderWidthButtonFocus:"2px",
  BorderBaseBase:"1px solid #b7b7b7",
  BorderBaseColor:"#b7b7b7",
  BorderBaseType:"solid",
  BorderBaseSize:"1px",
  BorderErrorBase:"1px solid #a32929",
  BorderErrorColor:"#a32929",
  BorderErrorType:"solid",
  BorderErrorSize:"1px",
  BoxShadowBaseFaint:"0 1px 0 0 rgba(22, 29, 37, 0.05)",
  BoxShadowBaseBase:"0 0 0 1px rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(63, 63, 68, 0.15)",
  BoxShadowBaseDeep:"0 0 0 1px rgba(6, 44, 82, 0.1), 0 2px 16px rgba(33, 43, 54, 0.08)",
  BoxShadowBaseLayer:"0 31px 41px 0 rgba(32, 42, 53, 0.2), 0 2px 16px 0 rgba(32, 42, 54, 0.08)",
  BoxShadowButtonBase:"0 0 0 1px rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(63, 63, 68, 0.15)",
  ColorBackgroundTooltipError:"#da2d30",
  ColorBackgroundInputError:"#faebeb",
  ColorBackgroundButtonDefaultBase:"#e6e6e6",
  ColorBackgroundButtonPrimaryBase:"#0a76bd",
  ColorBackgroundButtonDangerBase:"#da2d30",
  ColorBackgroundButtonDisabledBase:"#f7f7f7",
  ColorBadgeSuccessBackground:"#bbe5b3",
  ColorBadgeSuccessText:"#323232",
  ColorBadgeErrorBackground:"#ffcccc",
  ColorBadgeErrorText:"#323232",
  ColorBadgeInformationBackground:"#7fcbed",
  ColorBadgeInformationText:"#323232",
  ColorBadgeDefaultBackground:"#b7b7b7",
  ColorBadgeDefaultText:"#545454",
  ColorBadgeCriticalWarningBackground:"#fff0ad",
  ColorBadgeCriticalWarningText:"#323232",
  ColorBadgeNonCriticalWarningBackground:"#fff0ad",
  ColorBadgeNonCriticalWarningText:"#323232",
  ColorWhite:"#ffffff",
  ColorBlack:"#000000",
  ColorBlue50:"#f2f9fd",
  ColorBlue100:"#e6f4fb",
  ColorBlue200:"#d2edf9",
  ColorBlue300:"#7fcbed",
  ColorBlue400:"#0096db",
  ColorBlue500:"#0a76bd",
  ColorBlue600:"#075fa8",
  ColorBlue700:"#084b94",
  ColorBlue800:"#07387f",
  ColorGrey50:"#f7f7f7",
  ColorGrey100:"#f0f0f0",
  ColorGrey200:"#e6e6e6",
  ColorGrey300:"#b7b7b7",
  ColorGrey400:"#767676",
  ColorGrey500:"#545454",
  ColorGrey600:"#323232",
  ColorGrey700:"#292929",
  ColorGrey800:"#232323",
  ColorRed100:"#faebeb",
  ColorRed300:"#ffcccc",
  ColorRed500:"#da2d30",
  ColorRed700:"#a32929",
  ColorRed800:"#882222",
  ColorYellow100:"#fffbe5",
  ColorYellow300:"#fff0ad",
  ColorYellow500:"#ffd200",
  ColorYellow700:"#c7a400",
  ColorYellow800:"#8c7500",
  ColorGreen100:"#ddf2d9",
  ColorGreen300:"#bbe5b3",
  ColorGreen500:"#2e864d",
  ColorGreen700:"#277241",
  ColorGreen800:"#205f36",
  ColorBaseBlackBase:"#000000",
  ColorBaseWhiteBase:"#ffffff",
  ColorBaseCharcoalLightest:"#767676",
  ColorBaseCharcoalLighter:"#767676",
  ColorBaseCharcoalLight:"#545454",
  ColorBaseCharcoalBase:"#323232",
  ColorBaseCloudLighter:"#f7f7f7",
  ColorBaseCloudLight:"#e6e6e6",
  ColorBaseCloudBase:"#b7b7b7",
  ColorBaseCloudDark:"#b7b7b7",
  ColorBaseBlueLighter:"#e6f4fb",
  ColorBaseBlueLight:"#7fcbed",
  ColorBaseBlueBase:"#0a76bd",
  ColorBaseBlueDark:"#075fa8",
  ColorBaseBlueDarker:"#07387f",
  ColorBaseBlueText:"#323232",
  ColorBaseGreenLighter:"#ddf2d9",
  ColorBaseGreenLight:"#bbe5b3",
  ColorBaseGreenBase:"#2e864d",
  ColorBaseGreenDark:"#277241",
  ColorBaseGreenDarker:"#205f36",
  ColorBaseGreenText:"#323232",
  ColorBaseYellowLighter:"#fffbe5",
  ColorBaseYellowLight:"#fff0ad",
  ColorBaseYellowBase:"#ffd200",
  ColorBaseYellowDark:"#c7a400",
  ColorBaseYellowDarker:"#8c7500",
  ColorBaseYellowText:"#323232",
  ColorBaseRedLighter:"#faebeb",
  ColorBaseRedLight:"#ffcccc",
  ColorBaseRedBase:"#da2d30",
  ColorBaseRedDark:"#a32929",
  ColorBaseRedDarker:"#882222",
  ColorBaseRedText:"#323232",
  ColorBaseOrangeLighter:"#fffbe5",
  ColorBaseOrangeLight:"#fff0ad",
  ColorBaseOrangeBase:"#ffd200",
  ColorBaseOrangeDark:"#c7a400",
  ColorBaseOrangeDarker:"#8c7500",
  ColorBaseOrangeText:"#323232",
  ColorBorderBase:"#b7b7b7",
  ColorBorderDark:"#b7b7b7",
  ColorBorderFocus:"#0a76bd",
  ColorBorderError:"#a32929",
  ColorBorderButtonDefaultBase:"#b7b7b7",
  ColorBorderButtonDefaultFocus:"#075fa8",
  ColorBorderButtonPrimaryBase:"#07387f",
  ColorBorderButtonDangerBase:"#882222",
  ColorBorderButtonDisabledBase:"#b7b7b7",
  ColorTextButtonDefaultBase:"#323232",
  ColorTextButtonPrimaryBase:"#ffffff",
  ColorTextButtonDangerBase:"#ffffff",
  ColorTextButtonDisabledBase:"#767676",
  ColorTextBase:"#323232",
  ColorTextMuted:"#767676",
  ColorTextInverted:"#ffffff",
  ColorTextError:"#a32929",
  ColorSwitchChecked:"#0a76bd",
  ColorSwitchUnchecked:"#b7b7b7",
  ColorSwitchShadow:"#000000",
  FontFamilyBaseSans:"'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  FontFamilyBaseDisplayLarge:"'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  FontFamilyBaseDisplayMedium:"'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  FontFamilyBaseDisplaySmall:"'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  FontFamilyBaseHeading:"'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  FontFamilyBaseSubheading:"'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  FontFamilyBaseBody:"'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  FontFamilyBaseCaption:"'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  FontSizeBaseDisplayLarge:"28px",
  FontSizeBaseDisplayMedium:"26px",
  FontSizeBaseDisplaySmall:"20px",
  FontSizeBaseHeading:"16px",
  FontSizeBaseSubheading:"12px",
  FontSizeBaseBody:"14px",
  FontSizeBaseCaption:"12px",
  FontWeightBaseDisplayLarge:"600",
  FontWeightBaseDisplayMedium:"400",
  FontWeightBaseDisplaySmall:"400",
  FontWeightBaseHeading:"600",
  FontWeightBaseSubheading:"600",
  FontWeightBaseBody:"400",
  FontWeightBaseCaption:"400",
  FontWeightButtonBase:"400",
  LineHeightBaseDisplayLarge:"32px",
  LineHeightBaseDisplayMedium:"32px",
  LineHeightBaseDisplaySmall:"28px",
  LineHeightBaseHeading:"24px",
  LineHeightBaseSubheading:"16px",
  LineHeightBaseBody:"20px",
  LineHeightBaseCaption:"16px",
  LineHeightPageheaderTitle:"36px",
  LineHeightModalTitle:"28px",
  MediaQueriesXsmall:"(min-width: 0px) and (max-width: 575px)", // phone
  MediaQueriesSmall:"(min-width: 576px) and (max-width: 767px)", // tablet
  MediaQueriesMedium:"(min-width: 768px) and (max-width: 991px)", // desktop
  MediaQueriesLarge:"(min-width: 992px) and (max-width: 1199px)", // wide desktop
  MediaQueriesXlarge:"(min-width: 1200px) and (max-width: 1599px)", // wide desktop
  MediaQueriesXxlarge:"(min-width: 1600px)", // wide desktop
  HeightDropdownBase:"20px",
  HeightButtonBase:"36px",
  HeightButtonLarge:"42px",
  HeightButtonSmall:"24px",
  HeightSwitchBase:"22px",
  HeightSwitchSmall:"16px",
  HeightInputBase:"36px",
  HeightInputLarge:"42px",
  HeightInputSmall:"24px",
  MarginBaseXxsmall:"4px",
  MarginBaseXsmall:"10px",
  MarginBaseSmall:"12px",
  MarginBaseBase:"16px",
  MarginBaseLarge:"24px",
  MarginBaseXlarge:"32px",
  MarginBaseXxlarge:"104px",
  PaddingBaseXxsmall:"4px",
  PaddingBaseXsmall:"8px",
  PaddingBaseSmall:"12px",
  PaddingBaseBase:"16px",
  PaddingBaseLarge:"20px",
  PaddingBaseXlarge:"32px",
  PaddingButtonBase:"0px 16px",
  PaddingButtonLarge:"0px 16px",
  PaddingButtonSmall:"0px 4px",
  PaddingCardBase:"20px",
  PaddingDescriptionsBase:"12px",
  PaddingInputBase:"0px 12px",
  PaddingModalBase:"16px 20px",
  PaddingPageheaderHorizontal:"16px",
  PaddingPageheaderVertical:"20px",
  PaddingPageheaderTitle:"8px",
  SpacingBaseNone:"0px",
  SpacingBaseXxsmall:"4px",
  SpacingBaseXsmall:"8px",
  SpacingBaseSmall:"12px",
  SpacingBaseBase:"16px",
  SpacingBaseLarge:"20px",
  SpacingBaseXlarge:"32px",
  SpacingLayoutBase:"20px",
  SpacingLayoutLarge:"24px",
  SpacingLayoutXlarge:"32px",
  SpacingLayoutXxlarge:"40px",
  SpacingLayoutXxxlarge:"104px",
  WidthLayoutSmall:"960px",
  WidthLayoutLarge:"2000px",
  WidthScreenMaxXsmall:"575px",
  WidthScreenMaxSmall:"767px",
  WidthScreenMaxMedium:"991px",
  WidthScreenMaxLarge:"1199px",
  WidthScreenMaxXlarge:"1599px",
  WidthScreenMaxXxlarge:"100%",
  WidthScreenMinXsmall:"0px",
  WidthScreenMinSmall:"576px",
  WidthScreenMinMedium:"768px",
  WidthScreenMinLarge:"992px",
  WidthScreenMinXlarge:"1200px",
  WidthScreenMinXxlarge:"1600px",
  TextTransformBaseDisplayLarge:"none",
  TextTransformBaseDisplayMedium:"none",
  TextTransformBaseDisplaySmall:"none",
  TextTransformBaseHeading:"none",
  TextTransformBaseSubheading:"uppercase",
  TextTransformBaseBody:"none",
  TextTransformBaseCaption:"none",
}